import React from 'react'
import { Box } from '@mui/material'
import { FormBreakProps } from './_props'
import { getFormFieldContainerSx } from '../_utils/utils'

const FormBreak: React.FC<FormBreakProps> = ({ size = '1' }) => <Box sx={getFormFieldContainerSx(size)} />

export default FormBreak
